// Latest deployment addresses (2026-02-18, deployer 0xb006...).
// Both networks: Final Duel contract (DuelStarted/DuelResolved, reason in GameFinished)
// Update these values after each new deploy.
export const CONTRACT_ADDRESSES = {
  10143: '0x979D59e2e4fE2B4B6bbDe749a4f1eEf14C960BEc',
  143:   '0xf5d733e2904F32A13A384010538F670a6Af86eF7',
}

export const ESCROW_ADDRESSES = {
  10143: '0xF4Db220429CE743CDFC49a627d6C18cc2e1173b0',
  143:   '0x89071a31f6DCddBFBA9AeB739527167363c2348e',
}

export function getContractAddress(chainId) {
  return CONTRACT_ADDRESSES[chainId] || ''
}

export function getEscrowAddress(chainId) {
  return ESCROW_ADDRESSES[chainId] || ''
}

// Known reward tokens per chain. Add iconUrl for custom icon, name for display.
export const REWARD_TOKENS_BY_CHAIN = {
  10143: [
    { address: '0xBa566a14FdcC91C1a8dF72Ae84fa2d188823A744', symbol: 'LNX', name: 'Last Nad', decimals: 18, chainId: 10143 },
  ],
  143: [
    { address: '0x676f24158383DB9c1d1e3a20D75f2213F85C3A51', symbol: 'LNX', name: 'Last Nad', decimals: 18, chainId: 143 },
  ],
}
export const REWARD_TOKENS = REWARD_TOKENS_BY_CHAIN[143] || REWARD_TOKENS_BY_CHAIN[10143] || []

export const CONTRACT_ABI = [
  // ── Write ──
  "function createRoom(uint256 _fee, uint256 _max) external payable",
  "function joinRoom(uint256 _id) external payable",
  "function startEarly(uint256 _id) external",
  "function cancelRoom(uint256 _id) external",
  "function pickNumber(uint256 _id, uint8 _num) external",
  "function resolve(uint256 _id) external",
  "function leaveRoom(uint256 _id) external",
  "function cleanupTimedOutRoom(uint256 _id) external",
  "function transferOwnership(address newOwner) external",
  "function applyFee() external",
  "function withdraw() external",
  // ── Read ──
  // getRoom returns duelSystemNum as 10th field (0 while duel in progress; 2-10 after duel resolves)
  "function getRoom(uint256 _id) external view returns (uint256 entryFee, uint256 maxPlayers, uint256 playerCount, uint256 prizePool, uint256 currentRound, uint8 state, address winner, uint256 pickDeadline, uint256 createdAt, uint8 duelSystemNum)",
  "function getPlayers(uint256 _id) external view returns (address[])",
  "function getAlive(uint256 _id) external view returns (address[])",
  "function allAliveHavePicked(uint256 _id) external view returns (bool)",
  "function players(uint256 _id, address _player) external view returns (bool joined, bool alive, uint8 pick, bool hasPicked)",
  "function roomCount() external view returns (uint256)",
  "function getUserActiveRoom(address user) external view returns (bool hasActive, uint256 roomId, bool isTimedOut)",
  "function isRoomTimedOut(uint256 _id) external view returns (bool)",
  "function activeRoomOf(address) external view returns (uint256)",
  "function pendingFeePct() external view returns (uint256)",
  "function feeChangeAt() external view returns (uint256)",
  "function totalFees() external view returns (uint256)",
  "function feePct() external view returns (uint256)",
  // ── Events ──
  "event RoomCreated(uint256 indexed id, address indexed creator, uint256 fee, uint256 maxPlayers)",
  "event Joined(uint256 indexed id, address indexed player, uint256 count)",
  "event RoundStarted(uint256 indexed id, uint256 round, uint256 deadline)",
  "event Picked(uint256 indexed id, address indexed player, uint8 number)",
  "event RoundResolved(uint256 indexed id, uint256 round, uint8 eliminatedNumber)",
  // GameFinished now has a reason: 0=Winner 1=DuelDraw 2=TotalDraw 3=Cancelled
  "event GameFinished(uint256 indexed id, address indexed winner, uint256 prize, uint8 reason)",
  "event Left(uint256 indexed id, address indexed player, uint256 count)",
  "event RoomAutoCancelled(uint256 indexed id)",
  "event RoomCancelled(uint256 indexed id)",
  "event OwnershipTransferred(address indexed previousOwner, address indexed newOwner)",
  "event FeeScheduled(uint256 pendingPct, uint256 activeAt)",
  "event FeeUpdated(uint256 newFeePct)",
  "event FeesWithdrawn(address indexed to, uint256 amount)",
  // Final duel events
  "event DuelStarted(uint256 indexed id, uint256 round, uint256 deadline)",
  "event DuelResolved(uint256 indexed id, uint8 systemNum, address player1, uint8 pick1, address player2, uint8 pick2, address winner, uint8 reason)",
]

export const ESCROW_ABI = [
  "function tokenBalance(address user, address token) view returns (uint256)",
  "function getTokenBalance(address user, address token) view returns (uint256)",
  "function getNFTCount(address user) view returns (uint256)",
  "function getNFTAt(address user, uint256 index) view returns (address nftContract, uint256 tokenId, bool exists)",
  "function withdrawToken(address token, uint256 amount) external",
  "function withdrawNFT(address nftContract, uint256 tokenId) external",
]